require('./command.js');

PegasusTemplate.EditRowColorCommand = PegasusTemplate.Command.extend({
  klass: null,
  backup: null,
  descriptionClass: 'edited',
  description: function(){
    return Em.I18n.t('command_descriptions.edited_row_color');
  }.property(),
  childPosition: null,
  executeColor: null,
  execute: function(){
    var parent = PegasusTemplate.blockRegionInstance,
      element = this.get('klass').create({
        container: parent.container,
        sourceElement: this.get('sourceElement')
      }),
      child = parent.objectAt( this.get('childPosition') ),
      _super = this._super.bind(this);

    parent.removeObject( child );
    parent.insertAt( this.get('childPosition'), element );
    this._super();
  },
  unexecute: function(){
    var parent = PegasusTemplate.blockRegionInstance,
      child = parent.objectAt( this.get('childPosition') ),
      reborn = this.get('klass').create({
        container: parent.container,
        sourceElement: this.get('backup')
      }),
      _super = this._super.bind(this);

    parent.removeObject( child );
    parent.insertAt( this.get('childPosition'), reborn );

    Em.run.scheduleOnce( 'afterRender', reborn, function(){
      _super();
    });
  }
});
